
import React from 'react';
import {Provider} from 'react-redux';

import 'core-js';
import {createRoot} from 'react-dom/client';
import 'regenerator-runtime/runtime';

import {App} from './app.component';
import {initSentry} from './modules/sentry/init';
import {store} from './store/store';
import {checkForUpdate} from './utils/checkVersion';

const ROOT = document.getElementById('root');

initSentry();
checkForUpdate();

if (ROOT) {
    createRoot(ROOT).render(
        <Provider store={store}>
            <App/>
        </Provider>,
    );
}
